
import Button from '../base/Button';

export default function Header() {
  const scrollToForm = () => {
    const formElement = document.getElementById('contractor-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/519ba40ca4fe89039cbd6154721591df/f3df62ea6357ffd9f5c3ad1896919444.png" 
              alt="Bath Contractor For You" 
              className="h-12 w-auto"
            />
            <div>
              <h1 className="text-xl font-bold text-blue-900" style={{ fontFamily: '"Pacifico", serif' }}>
                Bath Contractor For You
              </h1>
              <p className="text-sm text-gray-600">Skip the Stress - We Find the Right Contractor</p>
            </div>
          </div>
          
          <div className="hidden md:flex items-center space-x-6">
            <nav className="flex space-x-6">
              <a href="#how-it-works" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">How It Works</a>
              <a href="#verification" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">Our Verification</a>
              <a href="#testimonials" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">Reviews</a>
            </nav>
            <Button onClick={scrollToForm} size="sm">
              Get Started Free
            </Button>
          </div>
          
          <button className="md:hidden p-2 rounded-lg hover:bg-gray-100">
            <i className="ri-menu-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
